import { StocksProfileEnum } from "../enums/StocksProfileEnum";
import { TemplateContentEnum } from "../enums/TemplateContentEnum";
import { Configuration } from "./Configuration";

export class ConfigurationTemplate {
    id: number;
    name: string;
    templateContent: TemplateContentEnum;
    rollsProfile: StocksProfileEnum;
    configuration: Configuration;

    public parse(obj: any) {
        if (obj.Id != null && obj.Id != undefined) this.id = obj.Id;
        if (obj.Name != null && obj.Name != undefined) this.name = obj.Name;
        if (obj.TemplateContent != null && obj.TemplateContent != undefined) this.templateContent = obj.TemplateContent;
        if (obj.RollsProfile != null && obj.RollsProfile != undefined) this.rollsProfile = obj.RollsProfile;
        if (obj.Configuration != null && obj.Configuration != undefined) {
            this.configuration = new Configuration();
            this.configuration.parse(obj.Configuration);
        }
    }
}
